import React from "react"

const NoteConfig = () => (
  <div className="mb-4 flex-center">
    This question-type has no options available.
  </div>
)

export default NoteConfig
